import { getUTCDateISOString } from "utils/date";

export const useDateUTC = (now = new Date()) => {
  return getUTCDateISOString(now);
};
